jQuery(document).ready(function($){
	$('.faqPregunta').on('click', function(event){
		event.preventDefault();
		$(this).next('.faqRespuesta').toggleClass('expanded');
		$(this).toggleClass('faqCollapse');
	});
});